import styled from 'styled-components';
import React from 'react';
import { Type } from '@spotify-internal/encore-web';
import { EventSource } from '../../graphql/graphql';
import { EmptyMarginStart } from './MessageIcon';
import { formatDate } from '../../lib/utils';
import { useTranslation } from 'react-i18next';
import { useTextDir } from '../../hooks/useTextDir';
const Status = styled.div `
  color: ${({ failed }) => (failed ? '#e91429;' : '#8f8f8f')};
`;
const Container = styled.div `
  display: inline-flex;
  gap: 0.5rem;
  align-self: ${({ isAdvisor }) => (isAdvisor ? 'start' : 'end')};
`;
const MessageState = ({ event, }) => {
    var _a, _b;
    const { t, i18n } = useTranslation();
    let statusText;
    if (event.source === EventSource.Customer) {
        statusText = t('YOU_AT_TEXT', {
            datetime: formatDate(event.persistedTimestamp, i18n.language),
        });
    }
    else {
        statusText =
            ((_a = event.messageEvent) === null || _a === void 0 ? void 0 : _a.from) !== null
                ? t('AT_TEXT', {
                    advisor_name: (_b = event.messageEvent) === null || _b === void 0 ? void 0 : _b.from,
                    datetime: formatDate(event.persistedTimestamp, i18n.language),
                })
                : formatDate(event.persistedTimestamp, i18n.language);
    }
    const { formattedMessage: statusFormatted, dir: statusDir } = useTextDir(statusText);
    const { formattedMessage: unableFormatted, dir: unableDir } = useTextDir(t('UNABLE_TO_DELIVER_TEXT'));
    if (event.failed) {
        return (React.createElement(Type, { as: "p", variant: "finale", dir: unableDir }, unableFormatted));
    }
    if (event.loading) {
        return React.createElement(React.Fragment, null, '  ');
    }
    return (React.createElement(Type, { as: "p", variant: "finale", dir: statusDir }, statusFormatted));
};
export const MessageStatus = ({ event, }) => {
    const isAdvisor = event.source === EventSource.Advisor;
    return (React.createElement(Container, { isAdvisor: isAdvisor },
        React.createElement(EmptyMarginStart, null),
        React.createElement(Status, { failed: event.failed },
            React.createElement(MessageState, { event: event }))));
};
